module.exports = __webpack_public_path__ + "img/ico-listening.fb6ff749.png";